import { Component, OnInit, Optional } from '@angular/core';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { GebaeudeSucheStandardComponent } from './gebaeude-suche-standard/gebaeude-suche-standard.component';
import { GebaeudeSucheEgidKantgidComponent } from './gebaeude-suche-egid-kantgid/gebaeude-suche-egid-kantgid.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';
import { SearchMode } from '../../../shared/enum/searchMode';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-gebaeude-suche',
  templateUrl: './gebaeude-suche.component.html',
  styleUrls: ['./gebaeude-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    GebaeudeSucheStandardComponent,
    GebaeudeSucheEgidKantgidComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class GebaeudeSucheComponent extends AbstractSearchComponent implements OnInit {
  searchMode: string;
  isAvPlusActive: boolean = false;

  constructor(
    stateService: SearchStateService,
    private appFormatConfigService: FormatConfigService,
    @Optional() private metaDirective?: MetaDirective
  ) {
    super(stateService);
    keysToTranslate<string>([
      'gebaeude.BreadcrumbSuche',
      'gebaeude.KantonalerGid',
      'gebaeude.Egid',
      'gebaeude.EgidKantGid',
      'gebaeude.SucheTitel',
      'EGID',
      'GEBAUT',
      'PROJEKTIERT'
    ]);
  }

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || SearchMode.searchStandard;
    this.addSub(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isAvPlusActive = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
      })
    );
  }
}
